import { Navigate, Outlet } from "react-router-dom";
import { token } from "../components/const";
const GuestLayout = () => {
   
    return (<>

        <Outlet />

    </>);
}

export default GuestLayout;